import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ScheduleSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ScheduleSVG;
